import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MapModule } from '@ebw-monorepo/map';
import { UserProfileComponent } from '@ebw-monorepo/user-profile';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { MapWrapperComponent } from './components/map-wrapper/map-wrapper.component';
import { NioEmptyPageComponent } from './components/nio-empty-page/nio-empty-page.component';
import { AuthGuard } from './guards/auth-guard.guard';
import { LoginGuard } from './guards/login.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        outlet: 'sidebarAction',
        loadChildren: () => MapModule
      },
      {
        path: 'fattibilita',
        outlet: 'sidebarAction',
        loadChildren: () => import('./modules/fattibilita/fattibilita.module').then((m) => m.FattibilitaModule)
      },
      {
        path: '',
        component: MapWrapperComponent
      },
      {
        path: 'profile',
        component: UserProfileComponent
      }
    ]
  },
  {
    // WARNING: NON cancellare: necessaria per la login EntraID dell'app NIO
    path: 'nio',
    component: NioEmptyPageComponent
  },
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', onSameUrlNavigation: 'reload', useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
